// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r-table {
  font-size: 14px;
}

  .r-table__cell-renderer--wrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .r-table__link {
    color: var(--color-blue-8);
    cursor: pointer;
  }

  .r-table__cell--not-editable * {
        overflow: hidden;
      }

  .r-table__cell--disabled {
      color: var(--color-gray-4);
    }

  .r-table__cell-col-money-globe-icon {
          fill: #007aff;
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

  .r-table .BaseTable__body {
    overflow: none;
  }

  .r-table .BaseTable__header {
    box-shadow: 0 2px 5px 0 rgb(197 198 199 / 50%), inset 0 1px 0 0 rgb(197 198 199 / 50%) !important;
    background: var(--color-grayscale-0);
    border-bottom: 0 !important;
    overflow: visible !important;
  }

  .r-table .BaseTable__header-row {
    background: var(--color-grayscale-0);
    border-bottom: 0 !important;
  }

  .r-table .BaseTable__header-cell {
    padding: 0;
    overflow: visible !important;
  }

  .r-table .BaseTable__row {
    border-bottom: 0;
  }

  .r-table .BaseTable__row-cell {
    padding: 0;
    overflow: visible !important;
  }

  .r-table .BaseTable__row-cell:last-child,
    .r-table .BaseTable__row-cell:first-child {
      padding: 0;
    }

  .r-table .BaseTable__table-frozen-left {
    box-shadow: none;
  }

  .r-table .BaseTable__header-cell:first-child {
      padding: 0;
    }

  .r-table .BaseTable__header-cell:hover {
      background: var(--color-grayscale-0);
    }

.r-table-col-cell__select {
    align-items: center;
    justify-content: center;
  }

.r-table-col-cell__first-col-buffer {
    align-items: center;
    justify-content: center;
  }
`, "",{"version":3,"sources":["webpack://./app/components/Table/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AAoFjB;;EAlFE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAII;QACE,gBAAgB;MAClB;;EAGF;MACE,0BAA0B;IAC5B;;EAII;UACE,aAAa;UACb,WAAW;UACX,YAAY;UACZ,iBAAiB;QACnB;;EAKN;IACE,cAAc;EAChB;;EAEA;IACE,iGAAiG;IACjG,oCAAoC;IACpC,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,oCAAoC;IACpC,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,4BAA4B;EAM9B;;EAJE;;MAEE,UAAU;IACZ;;EAGF;IACE,gBAAgB;EAClB;;EAGE;MACE,UAAU;IACZ;;EAEA;MACE,oCAAoC;IACtC;;AAKF;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;AAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB","sourcesContent":[".r-table {\n  font-size: 14px;\n\n  &__cell-renderer--wrap {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__link {\n    color: var(--color-blue-8);\n    cursor: pointer;\n  }\n\n  &__cell {\n    &--not-editable {\n      & * {\n        overflow: hidden;\n      }\n    }\n\n    &--disabled {\n      color: var(--color-gray-4);\n    }\n\n    &-col {\n      &-money {\n        &-globe-icon {\n          fill: #007aff;\n          width: 14px;\n          height: 14px;\n          margin-right: 5px;\n        }\n      }\n    }\n  }\n\n  & .BaseTable__body {\n    overflow: none;\n  }\n\n  & .BaseTable__header {\n    box-shadow: 0 2px 5px 0 rgb(197 198 199 / 50%), inset 0 1px 0 0 rgb(197 198 199 / 50%) !important;\n    background: var(--color-grayscale-0);\n    border-bottom: 0 !important;\n    overflow: visible !important;\n  }\n\n  & .BaseTable__header-row {\n    background: var(--color-grayscale-0);\n    border-bottom: 0 !important;\n  }\n\n  & .BaseTable__header-cell {\n    padding: 0;\n    overflow: visible !important;\n  }\n\n  & .BaseTable__row {\n    border-bottom: 0;\n  }\n\n  & .BaseTable__row-cell {\n    padding: 0;\n    overflow: visible !important;\n\n    &:last-child,\n    &:first-child {\n      padding: 0;\n    }\n  }\n\n  & .BaseTable__table-frozen-left {\n    box-shadow: none;\n  }\n\n  & .BaseTable__header-cell {\n    &:first-child {\n      padding: 0;\n    }\n\n    &:hover {\n      background: var(--color-grayscale-0);\n    }\n  }\n}\n\n.r-table-col-cell {\n  &__select {\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__first-col-buffer {\n    align-items: center;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
